module.exports = __webpack_public_path__ + "img/guest.5db42e92.png";